import packageJson from "../../package.json";
import { fastAccessLogo, fastDrawLogo, fastRecruitLogo, fastScoutLogo } from "../images";
import { FastModelProduct } from "../types";

const fastDrawLink = process.env.REACT_APP_FASTDRAW_URL as string;
const fastScoutLink = process.env.REACT_APP_FASTSCOUT_URL as string;
const fastRecruitLink = process.env.REACT_APP_FASTRECRUIT_URL as string;
const fastAccessLink = process.env.REACT_APP_FASTACCESS_URL as string;

export interface ProductInfo {
  logo: string;
  link: string;
}

export const fastDrawProduct: ProductInfo = { logo: fastDrawLogo, link: fastDrawLink };
export const fastScoutProduct: ProductInfo = { logo: fastScoutLogo, link: fastScoutLink };
export const fastRecruitProduct: ProductInfo = { logo: fastRecruitLogo, link: fastRecruitLink };
export const fastAccessProduct: ProductInfo = { logo: fastAccessLogo, link: fastAccessLink };

export const productMap = new Map<FastModelProduct, ProductInfo>([
  [FastModelProduct.FAST_DRAW, fastDrawProduct],
  [FastModelProduct.FAST_SCOUT, fastScoutProduct],
  [FastModelProduct.FAST_RECRUIT, fastRecruitProduct],
  [FastModelProduct.FAST_ACCESS, fastAccessProduct],
]);

export const version = packageJson.version;
